import * as types from 'store/mutation-types'

let id = 0

const state = {
  list: []
}

const mutations = {
  [types.ADD_NOTIFY](state, notification) {
    notification.id = ++id
    state.list.push(notification)
  },
  [types.REMOVE_NOTIFY](state, notificationId) {
    const loc = state.list.findIndex(item => item.id === notificationId)
    state.list.splice(loc, 1)
  },
  [types.CLEAR_NOTIFIES](state) {
    state.list.splice(0)
  }
}

const actions = {
  notify({ commit }, notification) {
    if (typeof notification !== 'object') {
      throw new Error('Invalid notification object.')
    }
    commit(types.ADD_NOTIFY, notification)
  },
  removeNotification({ commit }, notificationId) {
    commit(types.REMOVE_NOTIFY, notificationId)
  },
  clearNotifications({ commit }) {
    commit(types.CLEAR_NOTIFIES)
  }
}

export default {
  state,
  actions,
  mutations
}
